import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { TextSearchField, SingleMonthPickerField } from '@anytag/shared-molecules';
import { YoutubeCMSInvoicesFilterFormKeys } from './schemaTypes';

interface BasicFilterProps {
  onSubmit?: () => void;
}

export const BasicFilter = ({ onSubmit }: BasicFilterProps) => {
  const { t } = useTranslation();

  return (
    <Form.Fields>
      <TextSearchField<YoutubeCMSInvoicesFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.Invoices')}
      />
      <SingleMonthPickerField<YoutubeCMSInvoicesFilterFormKeys>
        name="month"
        clearable={false}
        onSubmit={onSubmit}
        className="max-w-[184px]"
      />
    </Form.Fields>
  );
};
